/* eslint-disable */
const hash = {
  "en-US": "36f922e9",
  "de-DE": "b2651f87",
  "es-ES": "f6383e45",
  "id-ID": "295dc025",
  "it-IT": "ea68f376",
  "jp-JP": "7bf88a20",
  "ko-KO": "83bbddfd",
  "nl-NL": "ffe885f5",
  "pl-PL": "073a0210",
  "pt-PT": "10faaade",
  "ru-RU": "aa630b6e",
  "tr-TR": "897406a0",
  "vi-VN": "57a6c361",
  "zh-CN": "2b658fa3",
  "zh-TW": "b7b359ad",
  "sv-SE": "7136e1b7",
  "fr-FR": "9a695868"
}
export default hash
